import { ContractExtensionEligibilityInfo } from '@/models/contractExtension/ContractExtensionEligibilityModel';
import Vue from 'vue';
import { MutationTree } from 'vuex';
import { PostgradContractExtensionState } from './state';
import Sort from '@/helpers/sort';

const mutations: MutationTree<PostgradContractExtensionState> = {
  SET_POSTGRAD_CONTRACT_EXTENSION_ELIGIBILITY(
    state,
    payload: { eligibilityInfo: ContractExtensionEligibilityInfo; courseId: number },
  ) {
    const { eligibilityInfo, courseId } = payload;

    if (!courseId || !eligibilityInfo) return;

    Vue.set(state.contractExtensionEligibilityByCourseId, courseId.toString(), {
      ...eligibilityInfo,
      extensionOptions: eligibilityInfo.extensionOptions
        .filter((o) => !!o.url)
        .sort(Sort.byField<ContractExtensionEligibilityInfo['extensionOptions'][number]>('period')),
    });
  },
};

export default mutations;
